document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".scroll-product, .scroll-category");

  if (!items.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains("scroll-category")) {
            entry.target.classList.add("scroll-category-visible");
          } else {
            entry.target.classList.add("scroll-product-visible");
          }
        } else {
          if (entry.target.classList.contains("scroll-category")) {
            entry.target.classList.remove("scroll-category-visible");
          } else {
            entry.target.classList.remove("scroll-product-visible");
          }
        }
      });
    },
    {
      threshold: 0.2
    }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
});